import { render, staticRenderFns } from "./ProductAttributeForm.vue?vue&type=template&id=48008059&scoped=true&"
import script from "./ProductAttributeForm.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48008059",
  null
  
)

export default component.exports